var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaginationEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "#6E7882",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16659 15.3958L5.27075 14.5L9.27075 10.5L5.27075 6.5L6.16659 5.60417L11.0624 10.5L6.16659 15.3958ZM14.2499 15.5V5.5H15.4999V15.5H14.2499Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationEnd);
export default __webpack_public_path__ + "static/media/paginationEnd.bbb6fd9ce823b7d5246195222e0bb8e5.svg";
export { ForwardRef as ReactComponent };